import { render, staticRenderFns } from "./ToolsSidebar.vue?vue&type=template&id=4f02245d&scoped=true"
import script from "./ToolsSidebar.vue?vue&type=script&lang=js"
export * from "./ToolsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToolsSidebar.vue?vue&type=style&index=0&id=4f02245d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f02245d",
  null
  
)

export default component.exports